import { ApiClient } from "./clients";
import { VerifiedResult } from "./models/auth/VerifiedResult";

export class VerificationManager {
  constructor(private readonly apiClient: ApiClient) {}

  verifyEmail(verificationCode: string): Promise<VerifiedResult> {
    return this.apiClient.post("/verify-email", { verificationCode });
  }

  resend(userUuid: string): Promise<VerifiedResult> {
    return this.apiClient.post("/resend", { userUuid });
  }
}
